import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const MetaPixel = function () {
    const { pathname, search } = useLocation();
    const lastPath = useRef(null);

    useEffect(() => {
        const currentPath = `${pathname}${search}`;

        if (lastPath.current === null) {
            lastPath.current = currentPath;
            return;
        }

        if (lastPath.current === currentPath) return;

        lastPath.current = currentPath;

        if (typeof window.fbq === 'function') {
            window.fbq('track', 'PageView');
        }
    }, [pathname, search]);

    return null;
};

export default MetaPixel;
